export default __webpack_public_path__ + "static/media/3f54158eb3ee2b7a4e2d9b8e626f44ce.e51b912d.svg";